import React from 'react';

import { useQuery, useMutation } from '@tanstack/react-query';

import FormContainer from '../../../../FormContainer';

import downloadDocument from '../../../../../../helpers/downloadDocument';
import MailService from '../../../../../../services/MailService';
import LoanService from '../../../../../../services/LoanService';
import ReportService from '../../../../../../services/ReportService';
import { useUiContext } from '../../../../../../context/UiContext';
import useWelcomeLetterForm from '../../../../../../forms/loan/welcomeLetter';

export default function WelcomeLetter({ loan, refetchLoan }) {
  const { showToast } = useUiContext();

  const { data: welcomeLetter } = useQuery({
    queryKey: ['welcomeLetter', loan?.id],
    queryFn: () => ReportService.getWelcomeLetter2(loan?.id),
    enabled: !!loan,
  });

  const hasWelcomeLetter = welcomeLetter && welcomeLetter.length > 0;

  const { mutate: deliverWelcomeLetter, isPending: isDelivering } = useMutation(
    {
      mutationFn: async () => {
        await MailService.sendMail({
          documentId: welcomeLetter?.[0]?.id,
          recipient: 'borrower',
        });
      },
      onSuccess: () => {
        showToast({
          text: 'Welcome letter delivered successfully',
          type: 'success',
        });
      },
      onError: (error) => {
        console.log(error);
        showToast({
          text: error?.response?.data?.message || 'Something went wrong',
          type: 'error',
        });
      },
    }
  );

  const { mutate: generateWelcomeLetter, isPending } = useMutation({
    mutationFn: async (formValues) => {
      if (
        formValues.servicing_transfer_date !== loan.servicing_transfer_date ||
        formValues.previous_servicer !== loan.previous_servicer
      ) {
        await LoanService.updateLoan({
          loanId: loan.id,
          formValues,
        });
      }

      return ReportService.getWelcomeLetter(loan.id);
    },
    onSuccess: () => {
      showToast({
        text: 'Welcome letter generated successfully',
        type: 'success',
      });
      refetchLoan();
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const download = async () => {
    try {
      downloadDocument(
        loan._welcome_letter.id,
        `${loan._welcome_letter.private_document.name}.pdf`
      );
    } catch (error) {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    }
  };

  const form = useWelcomeLetterForm(generateWelcomeLetter, loan);

  return (
    <FormContainer
      form={form}
      noBillComId
      isSubmitting={isPending}
      headerRight={
        hasWelcomeLetter ? (
          <div className="flex gap-5 md:gap-10 md:flex-row flex-col items-center">
            <button
              onClick={download}
              type="button"
              className="text-blue-500 underline hover:bg-transparent hover:text-blue-700 text-sm font-normal"
            >
              {loan._welcome_letter?.private_document?.name}
            </button>
            <button
              disabled={isDelivering}
              type="button"
              className="btn bg-indigo-500 hover:bg-indigo-600 text-white h-[37px] top-0"
              onClick={deliverWelcomeLetter}
            >
              Deliver Welcome Letter
            </button>
          </div>
        ) : null
      }
    />
  );
}
